module.exports = __webpack_public_path__ + "img/ClassA Desktop 800.13933ce9.gif";